import { can } from "../../../hooks/useEffectivePermissions";

export function hasGlobalTeamTasksManage(scopes) {
  return can(scopes, "team_tasks", "manage");
}

export function canManageTeamBoard(scopes, board) {
  if (isWorkspaceBoard(board)) {
    const role = board?.currentUserRole;
    return role === "owner" || role === "admin";
  }
  if (hasGlobalTeamTasksManage(scopes)) return true;
  const role = board?.currentUserRole;
  return role === "owner" || role === "admin";
}

export function canCreateTeamTask(scopes, board) {
  if (isWorkspaceBoard(board)) {
    const role = board?.currentUserRole;
    return role === "owner" || role === "admin" || role === "member" || role === "viewer";
  }
  return canManageTeamBoard(scopes, board);
}

export function canExecuteTeamTask(scopes, board, card, currentUserId) {
  if (isWorkspaceBoard(board)) {
    const role = board?.currentUserRole;
    return role === "owner" || role === "admin" || role === "member" || role === "viewer";
  }
  if (canManageTeamBoard(scopes, board)) return true;
  const uid = Number(currentUserId);
  if (!uid) return false;
  const assignees = (card?.assignees || []).map(Number);
  if (assignees.includes(uid)) return true;
  return false;
}

export function canManageBoardMembers(scopes, board) {
  return canManageTeamBoard(scopes, board);
}

export function isWorkspaceBoard(board) {
  return board && !board.spaceId && !board.leadId;
}
